<template>
  <div
    v-for="feature in packageStore.extraFeatures"
    :key="feature.Id"
    class="feature-item"
  >
    <h3>{{ feature.FeatureHeadline }}</h3>
    <p>{{ feature.FeatureDescription }}</p>
    <div class="quantity-control">
      <button
        @click="decreaseQuantity(feature.Id)"
        :disabled="quantities[feature.Id] === 0"
      >
        -
      </button>
      <span>{{ quantities[feature.Id] }}</span>
      <button
        @click="increaseQuantity(feature.Id, feature.IsMoreThanOneBuyable)"
      >
        +
      </button>
    </div>
    <p>Aylık : {{ feature.FeatureSellPrice }} TL</p>
    <p v-if="isYearly">
      Yıllık Olarak Faturalandırılır
      {{ (feature.FeatureSellPrice * 12).toFixed(2) }} TL
    </p>
    <p
      v-if="feature.IsMoreThanOneBuyable == false && quantities[feature.Id] > 0"
      class="text-red-500"
    >
      Bu özellikten sadece bir tane alabilirsiniz.
    </p>
  </div>

  <div class="total-price">
    <h4 v-if="!isYearly">Toplam: {{ totalPrice }} TL / Ay</h4>
    <h4 v-else>Toplam: {{ (totalPrice * 12).toFixed(2) }} TL / Yıl</h4>
  </div>
</template>

<script setup>
import { usePackageStore } from "@/stores/packageStore";
import { ref, defineEmits, computed, defineProps } from "vue";

const packageStore = usePackageStore();

const props = defineProps({
  quantities: {
    type: Object,
    required: true,
  },
  isYearly: {
    type: Boolean,
    required: true,
  },
});
const quantities = ref(props.quantities);

const emit = defineEmits(["handleQuantityChange"]);

// Miktarı artırma fonksiyonu
function increaseQuantity(id, isMoreThanOneBuyable) {
  if (isMoreThanOneBuyable || quantities.value[id] === 0) {
    quantities.value[id]++;
  }
  emit("handleQuantityChange", quantities.value);
}

// Miktarı azaltma fonksiyonu
function decreaseQuantity(id) {
  if (quantities.value[id] > 0) {
    quantities.value[id]--;
  }
  emit("handleQuantityChange", quantities.value);
}

// Toplam fiyatı hesaplayan computed fonksiyon
const totalPrice = computed(() => {
  return packageStore.extraFeatures
    .reduce((total, feature) => {
      return total + feature.FeatureSellPrice * quantities.value[feature.Id];
    }, 0)
    .toFixed(2);
});
</script>
<style scoped>
.feature-item {
  border: 1px solid #ddd;
  padding: 10px;
  margin-bottom: 10px;
}
.quantity-control {
  display: flex;
  align-items: center;
}
.quantity-control button {
  width: 30px;
  height: 30px;
}
.total-price {
  font-weight: bold;
  margin-top: 20px;
}
</style>
